// extracted by mini-css-extract-plugin
export var avatarContainer = "_6e-0";
export var avatarTypingWave = "_6e-i";
export var gray = "_6e-f";
export var green = "_6e-c";
export var icon = "_6e-9";
export var image = "_6e-1";
export var lg = "_6e-6";
export var md = "_6e-5";
export var presenceDot = "_6e-b";
export var red = "_6e-d";
export var sm = "_6e-4";
export var status = "_6e-a";
export var typingDot = "_6e-h";
export var typingPill = "_6e-g";
export var xl = "_6e-7";
export var xs = "_6e-3";
export var xxl = "_6e-8";
export var xxs = "_6e-2";
export var yellow = "_6e-e";